import { styled as n } from "./styled2.mjs";
import { MuiTelInput as p } from "./mui-tel-input.es.mjs";
import { inputBaseClasses as i, inputAdornmentClasses as a, iconButtonClasses as r } from "@mui/material";
const l = n(p)`
	width: ${({ fullWidth: t }) => !t && "324px"};
	max-width: 100%;

	.${i.root} {
		height: ${({ theme: t, $size: o }) => o === "small" ? t.spacing(4.5) : t.spacing(6.5)};
	}

	& input {
		padding-left: 0;
		padding-block: 14.5px !important;

		&.${i.inputSizeSmall} {
			padding-block: 6.5px !important;
		}
	}
	& button {
		padding-right: 0;
		padding-left: 0;
	}
	.${a.root} {
		position: relative;
		height: unset;
		cursor: pointer;

		.${r.root} {
			margin-right: ${({ theme: t }) => t.spacing(0.5)};

			&:hover {
				background: none;
			}
		}
	}
	${({ theme: t }) => t.breakpoints.down("md")} {
		width: 100%;
	}
`;
export {
  l as StyledPhoneField
};
//# sourceMappingURL=styles10.mjs.map
